module.exports = __webpack_public_path__ + "img/promotions.06dec6f.jpg?v=1756464842470";